import Slider from 'rc-slider';
import { cn } from '../../lib/cn';

// Labels to show on the slider — subset to avoid overcrowding
const LABEL_YEARS = new Set([1200, 1400, 1492, 1600, 1700, 1800, 1900, 1945, 2010]);

export default function TimeSlider({ value, onChange, availableYears }) {
  if (!availableYears || availableYears.length === 0) return null;

  const min = availableYears[0];
  const max = availableYears[availableYears.length - 1];

  // Build marks object — show label only for LABEL_YEARS, dot-only for the rest
  const marks = {};
  for (const year of availableYears) {
    marks[year] = LABEL_YEARS.has(year) ? { label: String(year) } : { label: '' };
  }

  // Snap to nearest available year
  const handleChange = (val) => {
    let closest = availableYears[0];
    let minDist = Math.abs(val - closest);
    for (const y of availableYears) {
      const dist = Math.abs(val - y);
      if (dist < minDist) {
        minDist = dist;
        closest = y;
      }
    }
    onChange(closest);
  };

  return (
    <div className={cn(
      'bg-white/95 dark:bg-gray-800/95 backdrop-blur-sm',
      'border-t border-gray-200 dark:border-gray-700',
      'px-8 py-4'
    )}>
      <Slider
        min={min}
        max={max}
        value={value}
        onChange={handleChange}
        marks={marks}
        step={null}
        styles={{
          rail: { backgroundColor: '#d1d5db', height: 4 },
          track: { backgroundColor: '#1f2937', height: 4 },
          handle: {
            borderColor: '#1f2937',
            backgroundColor: '#fff',
            height: 20,
            width: 20,
            marginTop: -8,
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
            opacity: 1,
          },
        }}
      />
      <div className="text-center mt-6 text-lg font-semibold text-gray-800 dark:text-gray-200">
        {value} CE
      </div>
    </div>
  );
}
